(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["melly-duftfinder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('melly-duftfinder')) {
  customElements.define('melly-duftfinder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.data = JSON.parse(this.querySelector('.melly-finder-data').textContent);
      this.stage = this.querySelector('.melly-finder-stage');
      this.answers = []; this.step = 0;
      this.addEventListener('change', event => {
        if (!event.target.matches('input[name="melly-scent-answer"]')) return;
        this.answers[this.step] = Number(event.target.value);
        this.querySelector('.melly-finder-next').disabled = false;
      });
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-finder-action]');
        if (!button || !this.contains(button)) return;
        const action = button.dataset.finderAction;
        if (action === 'next' && this.answers[this.step] !== undefined) {
          this.step += 1;
          if (this.step === this.data.questions.length) this.showResult(); else this.showQuestion(true);
        }
        if (action === 'back') { this.step = Math.max(0, this.step - 1); this.showQuestion(true); }
        if (action === 'reset') { this.answers = []; this.step = 0; this.showQuestion(true); }
        if (action === 'alternative') this.showResult(button.dataset.scent);
      });
      this.showQuestion(false);
    }
    escape(value) { return String(value).replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char])); }
    showQuestion(focus) {
      const d = this.data; const q = d.questions[this.step]; const selected = this.answers[this.step];
      this.stage.innerHTML = `<div class="melly-finder-step"><span>${this.escape(d.step)} ${this.step + 1} ${this.escape(d.of)} ${d.questions.length}</span><span>${Math.round(this.step / d.questions.length * 100)} %</span></div><div class="melly-finder-progress" aria-hidden="true"><span style="width:${this.step / d.questions.length * 100}%"></span></div><h3 tabindex="-1">${this.escape(q.title)}</h3><fieldset class="melly-finder-options"><legend class="melly-finder-sr">${this.escape(q.title)}</legend>${q.options.map((option,index) => `<label class="melly-finder-option"><input type="radio" name="melly-scent-answer" value="${index}" ${selected === index ? 'checked' : ''}><span>${this.escape(option.label)}</span></label>`).join('')}</fieldset><div class="melly-finder-actions">${this.step ? `<button type="button" class="melly-finder-back" data-finder-action="back">${this.escape(d.back)}</button>` : '<span></span>'}<button type="button" class="melly-finder-next" data-finder-action="next" ${selected === undefined ? 'disabled' : ''}>${this.escape(this.step === d.questions.length - 1 ? d.finish : d.next)}</button></div>`;
      if (focus) this.stage.querySelector('h3').focus({preventScroll:true});
    }
    rank() {
      const scores = this.data.scents.map(() => 0);
      this.answers.forEach((answer,index) => {
        const selected = this.data.questions[index].options[answer];
        selected.scores.forEach((score,scent) => { scores[scent] += score; });
      });
      return this.data.scents.map((scent,index) => ({...scent,score:scores[index],index})).sort((a,b) => b.score - a.score || a.index - b.index);
    }
    showResult(key) {
      const d = this.data; const ranking = this.rank(); const scent = ranking.find(item => item.key === key) || ranking[0];
      const product = d.products[scent.key];
      const imageHtml = product?.image ? `<img src="${this.escape(product.image)}" width="135" height="169" alt="${this.escape(scent.design)}">` : '';
      this.stage.innerHTML = `<p class="melly-eyebrow">${this.escape(d.result)}</p><div class="melly-finder-progress" aria-hidden="true"><span style="width:100%"></span></div><div class="melly-finder-result">${imageHtml}<div><h3 tabindex="-1">${this.escape(scent.name)}</h3><p class="melly-finder-design">${this.escape(scent.design)}</p><p>${this.escape(scent.reason)}</p><a class="melly-button" href="${this.escape(product.url)}">${this.escape(d.view)} ↗</a></div></div><div class="melly-finder-alternatives"><p>${this.escape(d.alternatives)}</p>${ranking.filter(item => item.key !== scent.key).slice(0,2).map(item => `<button type="button" class="melly-finder-alt" data-finder-action="alternative" data-scent="${item.key}">${this.escape(item.name)}</button>`).join('')}</div><p class="melly-finder-result-note">${this.escape(d.note)}</p><button type="button" class="melly-finder-reset" data-finder-action="reset">${this.escape(d.reset)}</button>`;
      this.stage.querySelector('h3').focus({preventScroll:true});
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
